module.exports = __webpack_public_path__ + "img/06.b8e2f94b.jpg";